import { ButtonProps, IconPositions } from "@/baseComponents";
import { Button } from "@/components/atoms/button";
import SvgDownloadIcon from "@/components/svg/DownloadIcon";
import { ButtonSizes, ButtonVariants } from "@/types/enums";
import { Box, chakra, Text } from "@chakra-ui/react";
import DOMPurify from "isomorphic-dompurify";

export interface TextWithDownloadProps {
  text?: string;
  download?: {
    url?: string;
    isDownloadLink?: boolean;
    target?: string;
    title?: string;
  };
}

export default chakra(TextWithDownload);
function TextWithDownload({ text, download, ...props }: TextWithDownloadProps) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={{ base: 6, md: 16 }}
      mx={{ base: -4, md: -9, lg: 0 }}
      py={{ base: 12, md: 20 }}
      px={{ base: 4, md: 5 }}
      rounded={{ base: "none", lg: "1rem" }}
      bgColor={"brand.grey"}
      {...props}
    >
      {text && (
        <Text
          textAlign="center"
          textStyle={{ base: "display.sm", lg: "display.xl" }}
          fontWeight={400}
          color={"brand.aubergine"}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(text.replace(/<\/p>/g, "</br>"), {
              ALLOWED_TAGS: ["strong", "br"],
            }),
          }}
          sx={{
            strong: {
              display: { base: "block", md: "inline" },
              textStyle: { base: "heading.sm", lg: "heading.xl" },
              fontWeight: 300,
              fontFamily: "Lausanne, sans-serif",
              color: "brand.cyan",
            },
          }}
        />
      )}
      {download?.url && (
        <Button
          isDownloadLink={download.isDownloadLink}
          url={download.url}
          text={download.title}
          target={download.target}
          icon={download.isDownloadLink ? <SvgDownloadIcon /> : undefined}
          iconPosition={IconPositions.Left}
          buttonVariant={ButtonVariants.Secondary}
          buttonSize={ButtonSizes.Large}
        />
      )}
    </Box>
  );
}
